<template>
  <div class="settings-view">
    <h1>{{ $t('routes.settings') }}</h1>
    <!-- <img v-if=""src="" alt="" /> -->
    <UserIcon class="user-icon-placeholder" :source="$auth.user.picture" />
    <RecycoInput type="text" :label="$t('words.first-name')" :value="$auth.user.given_name" disabled />
    <RecycoInput type="text" :label="$t('words.last-name')" :value="$auth.user.family_name" disabled />
    <RecycoInput type="email" :label="$t('words.email')" :value="$auth.user.email" disabled />
    <div class="action-buttons">
      <RecycoButton @click.native="logOut">{{ $t('log-out') }}</RecycoButton>
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "log-out": "Salir de la cuenta"
    },
    "en": {
      "log-out": "Log out"
    }
  }
</i18n>

<script>
  import UserIcon from '@/components/UserIcon.vue';
  import { RecycoInput, RecycoButton } from '@/components/recyco';

  export default {
    name: 'settings-view',
    components: {
      UserIcon,
      RecycoInput,
      RecycoButton,
    },
    methods: {
      logOut() {
        this.$auth.logout({
          returnTo: window.location.origin,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .settings-view {
    padding: 1em;

    display: flex;
    flex-direction: column;
  }

  .user-icon-placeholder {
    align-self: center;
    margin: 1em 0em;
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
  }
</style>
